import { render, staticRenderFns } from "./filter-two-class.vue?vue&type=template&id=5cc32fc9&scoped=true"
import script from "./filter-two-class.vue?vue&type=script&lang=js"
export * from "./filter-two-class.vue?vue&type=script&lang=js"
import style0 from "./filter-two-class.vue?vue&type=style&index=0&id=5cc32fc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc32fc9",
  null
  
)

export default component.exports